import React from 'react';
import { connectDeep } from 'redux-utils';

import App from 'models/app';

import Gallery from 'components/Gallery';
import DiscoveryPage from 'components/DiscoveryPage';
import { mapPageLayoutItems } from 'components/DiscoveryPage/utils';

import InstalledApps from './InstalledApps';

import { translations } from 'i18n';

const APP_DIGEST_PROPS = {
  showSettings: true
};

const mapStateToProps = (state, { showAll }) => {
  const {
    installed: {
      loading: installedLoading,
      error: installedError,
      entries: installedEntries = []
    },
    features: { flags },
    fetchPageLayout: { loading: fetchPageLayoutLoading },
    pageLayoutItems: { APP: pageLayoutItems = [] }
  } = state.registry;

  const { direction } = state.gallery;

  let showHiggsCU2 = false;
  if (flags) {
    showHiggsCU2 = flags.showHiggsCU2;
  }

  let showSearch = false;
  if (flags) {
    showSearch = flags.showSearch;
  }

  let loading = installedLoading;
  if (showAll) {
    loading = fetchPageLayoutLoading || pageLayoutItems.length === 0;
  }

  const error = installedError;
  const bannerLists = [];
  const categories = [];

  pageLayoutItems.forEach((item) => {
    if (item.type === 'BANNER_LIST') {
      bannerLists.push(item);
    } else if (item.type === 'APP_LIST') {
      const apps = item.apps.map((app) => App.selectFromState(app.id, state));
      categories.push({ ...item, apps });
    }
  });

  return {
    loading,
    error,
    bannerLists,
    categories,
    pageLayoutItems: mapPageLayoutItems(pageLayoutItems, state),
    direction,
    showHiggsCU2,
    showSearch,
    installedApps: installedEntries
      .reduce((apps, { appId }) => {
        const app = App.selectFromState(appId, state);
        if (app && app.isInstalledOrInstalling && !app.isClock) {
          apps.push(app);
        }
        return apps;
      }, [])
      .sort((appOne, appTwo) => {
        let sortValue = 0;
        if (
          (appOne.hasUpdate &&
            (!appTwo.hasUpdate || appTwo.hasPermissionWarning)) ||
          (appOne.hasPermissionWarning &&
            !(appTwo.hasPermissionWarning || appTwo.hasUpdate))
        ) {
          sortValue = -1;
        } else if (
          (appTwo.hasUpdate &&
            (!appOne.hasUpdate || appOne.hasPermissionWarning)) ||
          (appTwo.hasPermissionWarning &&
            !(appOne.hasPermissionWarning || appOne.hasUpdate))
        ) {
          sortValue = 1;
        }

        return sortValue;
      })
  };
};

const AppDiscoveryPage = (props) => (
  <DiscoveryPage isClock={false} {...props} />
);

const InstalledAppsPage = (props) => (
  <InstalledApps
    {...props}
    appDigestProps={{
      ...APP_DIGEST_PROPS,
      showUpdate: true,
      // TODO: Enable permission warning when blurb is added
      // https://jira.fitbit.com/browse/IPD-144741
      showPermissionWarning: false
    }}
  />
);

export default connectDeep(mapStateToProps)((props) => {
  const {
    page: {
      AppGallery: { listPageName, installedPageName, pageName }
    }
  } = translations;

  return (
    <Gallery
      rootUrl="/apps"
      installedPageName={installedPageName()}
      listPageName={listPageName()}
      pageName={pageName()}
      DiscoveryPage={AppDiscoveryPage}
      InstalledPage={InstalledAppsPage}
      {...props}
    />
  );
});
